import { render, staticRenderFns } from "./PlantDetail.vue?vue&type=template&id=f5409b52&"
import script from "./PlantDetail.vue?vue&type=script&lang=js&"
export * from "./PlantDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports